// skillsData.js — daftar teknologi & tools (tanpa icon path, agar ringan)
// Icon path tetap ada di SkillsSection.jsx
export const rawSkillsData = [
  { label: "C#",           category: "languages"  },
  { label: "C++",          category: "languages"  },
  { label: "JavaScript",   category: "languages"  },
  { label: "PHP",          category: "languages"  },
  { label: "Python",       category: "languages"  },
  { label: "SQL",          category: "languages"  },
  { label: "React",        category: "frameworks" },
  { label: "Tailwind CSS", category: "frameworks" },
  { label: "Laravel",      category: "frameworks" },
  { label: "Unity Engine", category: "tools"      },
  { label: "Git & GitHub", category: "tools"      },
  { label: "Figma",        category: "tools"      },
  { label: "PostgreSQL",   category: "tools"      },
  { label: "MySQL",        category: "tools"      },
];
